import useWindowSize from"./useWindowSize";var useMobileView=function(width){var windowWidth=useWindowSize();return windowWidth<width};export default useMobileView;
//# sourceMappingURL=useMobileView.js.map